import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import SMStemplateIndex from "../../../../components/SidetabPages/Configuration/SMSTemplate/SMStemplateIndex";

const SMSTemplate = () => {
  return (
    <>
      <AnnouncementBar />
      <SMStemplateIndex />
    </>
  );
};
export default SMSTemplate;
